__turbopack_context__.v({
  "backToToButtonBottom": "Brands-module-scss-module__oJfEYq__backToToButtonBottom",
  "backToTopButton": "Brands-module-scss-module__oJfEYq__backToTopButton",
  "backToTopButtonFooter": "Brands-module-scss-module__oJfEYq__backToTopButtonFooter",
  "brandContainer": "Brands-module-scss-module__oJfEYq__brandContainer",
  "brandIndexButton": "Brands-module-scss-module__oJfEYq__brandIndexButton",
  "brandItemWrapper": "Brands-module-scss-module__oJfEYq__brandItemWrapper",
  "brandListItem": "Brands-module-scss-module__oJfEYq__brandListItem",
  "brandsIndex": "Brands-module-scss-module__oJfEYq__brandsIndex",
  "brandsList": "Brands-module-scss-module__oJfEYq__brandsList",
  "header": "Brands-module-scss-module__oJfEYq__header",
  "headerContainer": "Brands-module-scss-module__oJfEYq__headerContainer",
});
